import { render, staticRenderFns } from "./RubberRight.vue?vue&type=template&id=9b3c3072&scoped=true&"
import script from "./RubberRight.vue?vue&type=script&lang=js&"
export * from "./RubberRight.vue?vue&type=script&lang=js&"
import style0 from "./RubberRight.vue?vue&type=style&index=0&id=9b3c3072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3c3072",
  null
  
)

export default component.exports